import React from 'react';
import { Provider } from 'react-redux';
import LWSLogo from "./assets/img/lws-logo.svg";
import BookingForm from './components/BookingForm'; 
import PreviewData from './components/PreviewData';
import store from './redux/store';

function App() {
  return (
    <Provider store={store}>
      <div>
        <header id="header">
            <div className="container">
                <img src= {LWSLogo} alt="logo" className="logo" />
                <div className="flex items-center">
                  <a className="text-white min-w-[50px] font-medium" href="/#">Home</a>
                  <button className="log-btn btn">Login</button>
                </div>
            </div>
        </header>
        <section>
            <BookingForm />
            <PreviewData />
        </section>
      </div>
    </Provider>
  );
}

export default App;
